import React, { useState } from "react";
import "./Home.css";
import "./HomeMobile.css";
import { Link } from "react-router-dom";
import useScrollAnimations from "../utils/useScrollAnimations";

const Home = () => {
  useScrollAnimations();

  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className="home">
        {/* Navbar */}
        <nav className="navbar">
            <div className="navbar-left">
            <Link to="/" className="logo" reloadDocument>Divori</Link>
                <div>
                    <div className={`nav-links ${menuOpen ? "active" : ""}`}>
                    <a href="#how-it-works">How It Works</a>
                    <a href="#testimonials">Testimonials</a>
                    <a href="#pricing">Pricing</a>
                </div>
                </div>
            </div>

            <Link to="/intro"><button className="start-now">START NOW</button></Link> 
        </nav>

    <div className="hero-div">
   
        <div className="hero" data-animate="fadeInUp">
        <p className="logo-mobile">Divori</p>
            <h1 className="title">Trusted by 8,000+ for Divorce Guidance</h1>
            <h2 className="main-text">Fast Divorce Advice at Your Fingertips.</h2>
            <p className="sub-text">
            Takes just 5 minutes.
            <br/>100% confidential and stress-free.
            </p>
            <Link to="/intro" className="cta-link"><button className="cta">GET YOUR GUIDE NOW</button></Link>
        </div>
    </div>


    {/* <section className="why-choose" data-animate="slideInLeft">
        <h2>Why Choose Divori?</h2>
        <div className="reasons">
            <div className="reason">
                <h3>* Make it easier for yourself * </h3>
                <p>→ Discover all the logistics you need to confidently start your divorce process</p>
            </div>
            <div className="reason">
                <h3>* Get Answers Now *</h3>
                <p>→ Access guidance without hours of searching or waiting for appointments</p>
            </div>
        </div>
    </section> */}

<div id="how-it-works" className="how-it-works" data-animate="fadeInUp">
        <div className="section-box">
            <div className="steps">

            <div className="step">
            <div className="icon">✉️</div>
                <h3>1) Delivered Straight to Your Inbox</h3>
                <p>
                Get a personalized, step-by-step divorce guidance with clear instructions, costs, and timelines,  <strong> sent directly to your inbox.</strong>
                </p>
                <a href="/sample.pdf" target="_blank" rel="noopener noreferrer" className="see-sample-btn">
                    See Sample
                </a>
            </div>
            <div className="step">
            <div className="icon">💪</div>
                <h3>2) Take Action with Confidence</h3>
                <p>
                Use your guide to navigate the process with confidence—save time, reduce stress, and move forward.
                </p>
            </div>
            </div>
        </div>
    </div>

    <div id="testimonials" className="testimonials-section" data-animate="fadeInUp">
        <h2>Testimonials</h2>
        <p>Trusted by thousands of individuals seeking advice for their divorce process.</p>
        <div className="testimonials">

            <div className="testimonial">
            <div className="testimonial-header">
                <div className="avatar-emily"></div>
                <div className="rating">★★★★★</div>
            </div>
            <h3>Emily R., 42</h3>
            <p className="testimonial-text">
            I felt lost until Divori broke everything down step by step. It saved me so much stress!
            </p>
            </div>

            <div className="testimonial">
            <div className="testimonial-header">
                <div className="avatar-samantha"></div>
                <div className="rating">★★★★★</div>
            </div>
            <h3>Samantha L., 39</h3>
            <p className="testimonial-text">Totally worth it! I finally know what to do and feel more in control of my situation.</p>
            </div>

            <div className="testimonial">
            <div className="testimonial-header">
                <div className="avatar-michael"></div>
                <div className="rating">★★★★★</div>
            </div>
            <h3>Michael H., 46</h3>
            <p className="testimonial-text">
            Divori saved me hours of research and gave me all the answers I needed.
            </p>
            </div>

            <div className="testimonial">
            <div className="testimonial-header">
                <div className="avatar-jessica"></div>
                <div className="rating">★★★★★</div>
            </div>
            <h3>Jessica M., 31</h3>
            <p className="testimonial-text">
             Simple and clear advice. I’d recommend this to anyone feeling overwhelmed.
            </p>
            </div>

            <div className="testimonial">
            <div className="testimonial-header">
                <div className="avatar-james"></div>
                <div className="rating">★★★★★</div>
            </div>
            <h3>James K., 35</h3>
            <p className="testimonial-text">
            I got actionable steps that made starting my divorce process so much easier.
            </p>
            </div>

            <div className="testimonial">
            <div className="testimonial-header">
                <div className="avatar-laura"></div>
                <div className="rating">★★★★★</div>
            </div>
            <h3>Laura K., 37</h3>
            <p className="testimonial-text">
                The guide was clear and fit my situation perfectly. It gave me the confidence to finally move forward.
            </p>
            </div>
        </div>
        </div>

    <div id="pricing" className="pricing-section" data-animate="fadeInUp">
        <div className="pricing-box">
            <h2>Affordable Pricing</h2>
            <p className="price">$5 per guide</p>
            <p>No hidden fees. One flat price.</p>
            <Link to="/intro" className="cta-link"><button className="cta-button">GET YOUR GUIDE NOW</button></Link>
        </div>
    </div>

    <footer className="footer">
        <div className="footer-container">
            <div className="footer-brand">
            <p>Divori</p>
            </div>
            <div className="footer-links">
            <div className="footer-section">
                <h4>Terms and Conditions</h4>
                <ul>
                <li>
                <Link to="/terms-and-conditions" style={{ textDecoration: "none", color: "#007bff" }}>
                    Terms and Conditions
                </Link>
                </li>
                </ul>
            </div>
            <div className="footer-section">
                <h4>Contact</h4>
                <ul>
                <li><a href="#">Email</a></li>
                <li><a href="#">Instagram</a></li>
                <li><a href="#">Facebook</a></li>
                </ul>
            </div>
            </div>
        </div>
        <div className="footer-bottom">
            <p>© 2025 Divori. All rights reserved.</p>
        </div>
    </footer>
    </div>
  );
};

export default Home;

